import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { PlayButton } from '../PlayButton';

export const RegisterVimeo = {

  // Internal id of the component
  id: 'vimeo',

  // Visible label
  label: 'Vimeo',

  // Fields the user need to fill out when adding an instance of the component
  fields: [{
    name: 'id',
    label: 'Video ID',
    widget: 'string',
    default: '237194047',
    hint: 'Indsæt den del af url-adressen som kommer efter "https://vimeo.com/" - det er som regel et nummer på 8 tegn',
  }],

  // Pattern to identify a block as being an instance of this component
  // pattern: /^vimeo (\S+)$/,
  pattern: /<Vimeo id=\{`(\d*)`\} \/>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
      id: match[1],
    };
  },

  // Function to create a text block from an instance of this component
  toBlock({ id }) {
    return `<Vimeo id={\`${id}\`} />`;
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview({ id }) {
    return (
      <Vimeo id={id} isPreviewMode />
    );
  },

};

// eslint-disable-next-line
export const Vimeo = ({ id, isPreviewMode }) => {

  const [ shouldDisplayVideo, setShouldDisplayVideo ] = useState(false);

  const [ thumbnail, setThumbnail ] = useState('');
  const [ title, setTitle ] = useState('');

  useEffect(() => {
    if (!isPreviewMode) {
      fetch(`https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${id}&width=960&height=720`)
        .then((res) => res.json())
        .then((res) => {
          setThumbnail(res.thumbnail_url);
          setTitle(res.title);
        })
        .catch(() => {
          // just display the video if fetching fails
          setShouldDisplayVideo(true);
        });
    }
  }, []);

  const handleClick = () => {
    if (Cookies.get('accept-cookies') === 'true') {
      setShouldDisplayVideo(true);
    } else {
      window.location.href = `https://vimeo.com/${id}`;
    }
  };

  return (
    <div className="video">
      <div
        style={{
          padding: 0,
          width: '100%',
          paddingTop: '56.25%',
          position: 'relative',
        }}
      >
        { (!shouldDisplayVideo && thumbnail !== '' && !isPreviewMode) && (
          <>
            <img
              src={thumbnail}
              alt={title}
              style={{
                width: '100%',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <button
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'rgba(0,0,0,.2)',
                margin: 0,
                padding: 0,
                border: 0,
                textAlign: 'center',
              }}
              type="button"
              onClick={() => handleClick()}
            >
              <PlayButton />
            </button>
          </>
        )}
        { (shouldDisplayVideo || isPreviewMode) && (
          <>
            <iframe
              title={title}
              src={`https://player.vimeo.com/video/${id}?autoplay=${isPreviewMode ? 0 : 1}&color=23652e&title=0&byline=0&portrait=0`}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
            <script src="https://player.vimeo.com/api/player.js" />
          </>
        )}
      </div>
    </div>
  );
};
